import Users from "views/service/Users/User";
import UserEdit from "views/service/Users/UserEdit";
import CustomerEdit from "views/service/Users/CustomerEdit";
import CompanyEdit from "views/service/Companies/CompanyEdit";
import DeviceEdit from "views/service/Devices/DeviceEdit";
import Terminal from "views/service/Terminals/Terminal";
import UserProfile from "views/service/profile/Profile"
import {
  Dashboard,
  AllDevices,
  SingleDeviceTable,
  FileManager,
  Todos
} from "views/service/app/index";

import {userDashboard, userAllDevices, userSingleDeviceTable} from "views/customer/app/index";
import userUserProfile from "views/customer/profile/Profile"


const serviceRoutes = [
    { path: "/dashboard", component: Dashboard },
    { path: "/users", component: Users },
    { path: "/users/add", component: UserEdit },
    { path: "/users/edit/:id", component: UserEdit },
    { path: "/customers/add", component: CustomerEdit },
    { path: "/customers/edit/:id", component: CustomerEdit },
    { path: "/companies/add", component: CompanyEdit },
    { path: "/companies/edit/:id", component: CompanyEdit },
    { path: "/devices/add", component: DeviceEdit },
    { path: "/devices/edit/:id", component: DeviceEdit },
    { path: "/devices/terminal/:id", component: Terminal },
    { path: "/devices/all", component: AllDevices },
    { path: "/devices/single", component: SingleDeviceTable },
    { path: "/filemanager", component: FileManager },
    { path: "/profile", component: UserProfile },
    { path: "/notifications", component: Todos}
];

const serviceUserRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/users", component: Users },
  { path: "/devices/terminal/:id", component: Terminal },
  { path: "/devices/all", component: AllDevices },
  { path: "/devices/single", component: SingleDeviceTable },
  { path: "/filemanager", component: FileManager },
  { path: "/profile", component: UserProfile },
  { path: "/notifications", component: Todos}
];

const userRoutes = [
  { path: "/dashboard", component: userDashboard },
  { path: "/devices/all", component: userAllDevices },
  { path: "/devices/single", component: userSingleDeviceTable },
  { path: "/profile", component: userUserProfile }
]


export {serviceRoutes, serviceUserRoutes, userRoutes};